import { Response } from '@marketplace-web/core-api/api-client-util'
import { transformCurrencyAmountDto } from '@marketplace-web/currency/currency-data'

import {
  BumpMotivationDto,
  BumpMotivationModel,
  BumpOptionDto,
  BumpOptionModel,
  BumpOptionResp,
  BumpOptionsDto,
  BumpOptionsModel,
} from '../types/bump-options'
import { transformBumpOrderItem } from './bump-order'

export const transformBumpOption = ({
  days,
  payable,
  description,
  default: isDefault,
  best_value,
  international,
  countries,
  total,
  discount,
  discounted,
  sales_tax,
  push_up_order_items,
}: BumpOptionDto): BumpOptionModel => {
  return {
    id: `${days}${international ? '-int' : ''}`,
    days,
    isDefault,
    description,
    isBestValue: !!best_value,
    international,
    countries,
    payable: transformCurrencyAmountDto(payable),
    total: transformCurrencyAmountDto(total),
    discount: transformCurrencyAmountDto(discount),
    discounted: transformCurrencyAmountDto(discounted),
    salesTax: sales_tax ? transformCurrencyAmountDto(sales_tax) : undefined,
    pushUpOrderItems: push_up_order_items.map(transformBumpOrderItem),
  }
}

export const transformBumpOptions = (dtos: Array<BumpOptionDto>): Array<BumpOptionModel> =>
  dtos.map(transformBumpOption)

export const transformBumpMotivation = (dto: BumpMotivationDto): BumpMotivationModel => ({
  title: dto.title,
  description: dto.description,
  highlight: dto.highlight,
})

export const transformBumpsOptions = (dto: BumpOptionsDto): BumpOptionsModel => ({
  motivation: dto.motivation ? transformBumpMotivation(dto.motivation) : undefined,
  options: dto.options ? transformBumpOptions(dto.options) : [],
  hasLocalOptions: dto.has_local_options,
})

export const transformBumpOptionsResponse = (response: Response<BumpOptionResp>) =>
  transformBumpsOptions(response)
